import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ReactComponent as EditIcon } from "../../assets/icons/edit-pencil-colored.svg";
import { ibanToBank } from "../../utils/Utils";

function CashoutBankBox(props) {
  const { iban = "", banks = [], onClick = () => {} } = props;
  const [bank, setBank] = useState(ibanToBank(iban || "", banks));

  useEffect(() => {
    setBank(ibanToBank(iban || "", banks));
  }, [iban]);

  return (
    <Box
      onClick={onClick}
      sx={{
        mt: 1,
        width: "100%",
        minHeight: 40,
        px: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: "8px",
        border: (theme) => `1px solid ${theme.palette.grey[5]}`,
      }}
    >
      {Boolean(iban) ? (
        <>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img width={24} height={24} src={bank.logoUrl} />
            <Typography ml={1} variant="body2" color="grey.2">
              {`واریز به شبای ${bank.name}`}
            </Typography>
          </Box>
          <EditIcon width={16} height={17} />
        </>
      ) : (
        <Typography variant="body2" color="grey.2">
          شماره شبای خودرا وارد کنید
        </Typography>
      )}
    </Box>
  );
}

export default CashoutBankBox;
